import { render, staticRenderFns } from "./teamUi.vue?vue&type=template&id=7e16d812&scoped=true"
import script from "./teamUi.vue?vue&type=script&lang=js"
export * from "./teamUi.vue?vue&type=script&lang=js"
import style0 from "./teamUi.vue?vue&type=style&index=0&id=7e16d812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e16d812",
  null
  
)

export default component.exports